import React, { useState } from 'react';
import './hospital&doctormodal.css';
import { toast, cssTransition } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddDoctorModal = ({ show, onClose, onSave, hospitalId }) => {
  console.log("show is:", show);
  console.log("AddDoctorModal component is rendered");
  console.log("AddDoctorModal component rendered with props:");
  console.log("show:", show);
  console.log("onClose:", onClose);
  console.log("onSave:", onSave);
  console.log("hospitalId:", hospitalId);
  const [doctorName, setDoctorName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [email, setEmail] = useState('');

  if (!show) {
    console.log("AddDoctorModal is not shown because 'show' is false");
    return null;
  }

  const handleSave = () => {
    if(doctorName.trim()==='')
        {
            alert("Doctor Name Cannot be Empty")
            return
        }

        if(mobileNumber){
          if(mobileNumber.length!==10){
            alert("Mobile Number must be 10 digit")
            return
          }
        
        }
        
        

        if(email){
          const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailPattern.test(email)) {
            alert("Please enter a valid email address.");
            return;
        }
      }
      const formattedDoctorName = `Dr. ${doctorName.toString()}`;
      const formattedDoctorNamestring=formattedDoctorName.toString();
      console.log("type of",typeof(formattedDoctorNamestring));
     
      
      onSave(formattedDoctorNamestring, hospitalId, mobileNumber, email);
      toast.success("Doctor added successfully!");
    setDoctorName('');
    setMobileNumber('');
    setEmail('');
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <ToastContainer position="bottom-right" autoClose={5000} />
      <div className="modal-container">
        <div className="modal-header">
          <h2 className="modal-title">Add New Doctor</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Doctor Name:</label>
            <div style={{ display: "flex", alignItems: "center" }}>
            <span>Dr.</span>
            <input
              type="text"
              value={doctorName}
              onChange={(e) => setDoctorName(e.target.value)}
              className="modal-input"
              placeholder="Enter doctor's name"
            />
            </div>
          </div>
          <div className="form-group">
            <label>Mobile Number:</label>
            <input
              type="text"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              className="modal-input"
              placeholder="Enter mobile number"
            />
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="modal-input"
              placeholder="Enter email address"
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="modal-submit" onClick={handleSave}>Save</button>
          {/* <button className="modal-cancel" onClick={onClose}>Cancel</button> */}
        </div>
      </div>
    </div>
  );
};

export default AddDoctorModal;
